module.exports = __webpack_public_path__ + "img/script-task.73f93e0e.svg";